import React, { useState, useRef, useEffect } from "react";
import "../Sportsbook.css";
import "./playergame.css";
import {
  API_URL,
  endPoints,
  sportEndPoint,
} from "../../../constant/Environment";
import { useSelector, useDispatch } from "react-redux";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import {
  fetchAllData,
  getAllBetData,
  getAllData,
  getData,
} from "../../../Utility/API";
import Loader from "../../../components/Loader";
import {
  TabPanel,
  checkGeoAndVpn,
  getCookie,
  setCookie,
} from "../../../Utility/functions/Helper";
import MultiPlayerCard from "../../../components/MultiPlayerCard";
import { createBrowserHistory } from "history";
import { Container, Row, Col, Form, InputGroup, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { SPORTS } from "../../../constant/enum";
import {
  getSportImageUrl,
  getLeagueImageUrl,
  getMarketSingleData,
  getMatchListData,
  getKeyPairList,
} from "../../../Utility/functions/Helper";
import axios from "axios";
import { Actions } from "../../../redux/Actions/Actions";
import LabelWithImage from "../../../components/LabelWithImage";
import MailVerification from "../../../screens/MailVerification/notverified";
import Mailverified from "../../../screens/MailVerification/verified";
import FailedGeocheck from "../../../screens/FailedGeocheck/index";
import { AiOutlineDollarCircle } from "react-icons/ai";
import { BiSolidGift, BiSolidOffer } from "react-icons/bi";
import PromotionList from "../../PromotionList";
import { LeagueVisit, GameVisit } from "../../../Utility/API";
import InstallAppButton from "../../../components/InstallAppButton";
import FooterAppButton from "../../../components/BettDraftAppButton/FooterAppButton";
import OfferList from "../../OfferList";
import DepositMessage from "./DepositMessage";
import WheelOfFortune from "../../WheelofFortune";
import { SuccesToast, ErrorToast } from "../../../components/Toast/message";
import { Helmet } from "react-helmet";
var leagueId = "";
var SportId = "";
var tabIndexValue = 0;
var tabdatevalue = 0;
var ActiveGameName = "";
let browsereventId = "";
let browserdate = "";
let browsermatch = "";
const MultiPlayerGames = (props) => {
  let params = new URLSearchParams(window.location.search);
  let ref = params.get("ref") || "";
  let campaign = params.get("campaign") || "";
  if (ref) {
    setCookie("ref", ref, 30); // Set the cookie to expire in 30 days
  }
  if (campaign) {
    setCookie("campaign", campaign, 30); // Set the cookie to expire in 30 days
  }

  const [openWheel, setOpenWheel] = useState(false);
  const history = createBrowserHistory();

  let deeplink = new URLSearchParams(window.location.search);

  browsereventId = deeplink.get("eventId") || "";
  browserdate = deeplink.get("date")?.replace(/,(\w{3})(\d+)/, ", $1 $2") || "";
  browsermatch = deeplink.get("match")?.replace(/vs/g, " vs ") || "";

  const state = useSelector((state) => state);
  const [offerList, setOfferList] = useState([]);
  const { auth, sidebar } = state;
  const [value, setValue] = useState(0);
  const [teamValue, setTeamValue] = useState(0);
  const [dateIndex, setDateIndex] = useState(0);

  const [datevalue, setDatevalue2] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const [playerList, setPlayerList] = useState([]);
  const [activeIndex, setActiveIndex] = useState("");
  const [activeTabName, setActiveTabName] = useState("");

  const [activeshortTabName, setActiveshortTabName] = useState("");

  const [activeMatchTabName, setActiveMatchTabName] = useState("");
  const [activeTabDate, setActiveTabDate] = useState("");

  const [selectedSportId, setSelectedSportId] = useState("");
  const [selectedLeagueId, setSelectedLeagueId] = useState("");
  const [tabList, setTabList] = useState([]);

  const [dateList, setDateList] = useState([]);
  const [matchTabList, setMatchTabList] = useState([]);
  const [eventList, setEventList] = useState([]);

  const game = useSelector((state) => state).sidebar.game;
  const selectedGameId = useSelector((state) => state).sidebar.gameId;
  const selectedGame = useSelector((state) => state).sidebar.game;

  const [dateIndexvalue, setDateIndexvalue] = useState(0);
  // const [promoPage,setPromoPage] = useState(false);

  const [openlength, setopenLength] = useState(0);

  const promoPage = state.betslip.promoPage;

  const [foundleague, setFoundleague] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    tabIndexValue = newValue;
    setSearchQuery('');
  };

  const handleDateChange = (event, newValue) => {
    tabdatevalue = newValue;
    tabIndexValue = 0;

    setDateIndex(newValue);
    setValue(0);
    setSearchQuery('');
  };

  const handleTeamChange = (event, newValue) => {
    setTeamValue(newValue);
    setValue(0);
    setSearchQuery('');
  };

  const navigate = useNavigate();

  const [sportsList, setSportsList] = useState([]);
  const [league, setLeague] = useState([]);
  const dispatch = useDispatch();

  const [active, setactive] = useState(0);

  const statecode = state?.auth?.isAuthenticated
    ? state?.auth?.stateInfo?.stateCode
    : "";
  const statename = state?.auth?.isAuthenticated
    ? state?.auth?.stateInfo?.stateName
    : "";

      const pathname = window.location.pathname;

  const geo_access = state?.auth?.geoWallet;
  const [geoResult, setGeoResult] = useState(false);
  const geo_response = state?.auth?.geoResponse;
    const [segments, setSegments] = useState([]);
    const [probabilities, setProbabilities] = useState([]);
    const [colors, setColors] = useState([]);
    const [wofData, setWofData] = useState({});
  
    const handleCloseWheel = () => setOpenWheel(false);

  const email_popup = state?.auth?.user?.email_popup;

      const handleOpenWheel = async () => {
      try {
        let url = `${endPoints.api.GET_SPIN_VALUES}/${state?.auth?.user?.idUser || 0}`;
        const response = await getAllData(url);
        if (
          response.status === "success" &&
          response?.data?.segments?.length &&
          response?.data?.probabilities?.length &&
          response?.data?.colors.length
        ) {
          setSegments(response?.data?.segments);
          setProbabilities(response?.data?.probabilities);
          setColors(response?.data?.colors || []);
          setWofData(response?.data);
          setOpenWheel(true); // Opening wheel only when data is coming
        } else {
          SuccesToast("Something went wrong. Please try again later.");
        }
      } catch (err) {
        console.error(err);
        ErrorToast("Something went wrong. Please try again later.");
      }
    };

  useEffect(() => {
    (async () => {
      let url = `${sportEndPoint.api.leagueList}`;
      const PopularLeague = await getAllBetData(url);

      // const filteredData = PopularLeague.filter(item => item.location !== statecode);

      const filteredData = PopularLeague?.filter((item) => {
        if (Array.isArray(item?.location)) {
          return !item?.location.includes(statecode);
        } else {
          return item?.location !== statecode;
        }
      });

      if (filteredData?.length > 0) {
        leagueId = filteredData[0]?.id;
        setSelectedLeagueId(filteredData[0]?.id);
      }

      setIsLoading(true);
      let updated = filteredData?.map((elem) => ({
        ...elem,
        label: elem?.name?.replace(/\s/g, "").toLowerCase(),
        img: getLeagueImageUrl(elem?.name?.replace(/\s/g, "_").toLowerCase()),
      }));
      setLeague(updated);

      if (updated?.length > 0) {
        if (browsereventId) {
          const foundLeague = filteredData?.find(
            (league) => league.id == browsereventId
          );
          const mainidname = foundLeague ? foundLeague.name : "";

          if (foundLeague) {
            dispatch({
              type: Actions.SET_GAME,
              data: mainidname,
              Id: browsereventId,
            });
            ActiveGameName = mainidname;
            fetchPlayerData(browsereventId, "league", true);
          } else {
            dispatch({
              type: Actions.SET_GAME,
              data: updated[0]?.name,
              Id: updated[0]?.id,
            });
            ActiveGameName = updated[0]?.name;
            fetchPlayerData(updated[0]?.id, "league", false);
          }
        } else {
          dispatch({
            type: Actions.SET_GAME,
            data: updated[0]?.name,
            Id: updated[0]?.id,
          });
          ActiveGameName = updated[0]?.name;
          fetchPlayerData(updated[0]?.id, "league", false);
        }
      }

      let url1 = `${sportEndPoint.api.sports}`;
      const PopularSport = await getAllBetData(url1);
      let updatedSport = PopularSport?.map((elem) => ({
        ...elem,
        label: elem?.name?.replace(/\s/g, "").toLowerCase(),
        img: getSportImageUrl(elem?.name?.replace(/\s/g, "_").toLowerCase()),
      }));

      setSportsList(updatedSport);
      if (filteredData?.length === 0) {
        dispatch({
          type: Actions.SET_GAME,
          data: updatedSport[0]?.name,
          Id: updatedSport[0]?.id,
        });
        ActiveGameName = updatedSport[0]?.name;
        SportId = updatedSport[0]?.id;
        setSelectedSportId(updatedSport[0]?.id);
        fetchPlayerData(updatedSport[0]?.id, "sport");
      }
    })();

    return () => {
      // this now gets called when the component unmounts
    };
  }, [statecode]);

  useEffect(() => {
    if (browsereventId != "") {
      (async () => {
        let url = `${sportEndPoint.api.leagueList}`;
        const PopularLeague = await getAllBetData(url);

        const filteredData = PopularLeague?.filter((item) => {
          if (Array.isArray(item.location)) {
            return !item.location.includes(statecode);
          } else {
            return item.location !== statecode;
          }
        });

        if (filteredData?.length > 0) {
          leagueId = filteredData[0]?.id;
          setSelectedLeagueId(filteredData[0]?.id);
        }

        setIsLoading(true);
        let updated = filteredData?.map((elem) => ({
          ...elem,
          label: elem?.name?.replace(/\s/g, "").toLowerCase(),
          img: getLeagueImageUrl(elem?.name?.replace(/\s/g, "_").toLowerCase()),
        }));
        setLeague(updated);

        if (updated?.length > 0) {
          if (browsereventId) {
            const foundLeague = filteredData?.find(
              (league) => league.id == browsereventId
            );
            const mainidname = foundLeague ? foundLeague.name : "";

            if (foundLeague) {
              dispatch({
                type: Actions.SET_GAME,
                data: mainidname,
                Id: browsereventId,
              });
              ActiveGameName = mainidname;
              fetchPlayerData(browsereventId, "league", true);
            } else {
              dispatch({
                type: Actions.SET_GAME,
                data: updated[0]?.name,
                Id: updated[0]?.id,
              });
              ActiveGameName = updated[0]?.name;
              fetchPlayerData(updated[0]?.id, "league", false);
            }
          } else {
            dispatch({
              type: Actions.SET_GAME,
              data: updated[0]?.name,
              Id: updated[0]?.id,
            });
            ActiveGameName = updated[0]?.name;
            fetchPlayerData(updated[0]?.id, "league", false);
          }
        }

        let url1 = `${sportEndPoint.api.sports}`;
        const PopularSport = await getAllBetData(url1);
        let updatedSport = PopularSport?.map((elem) => ({
          ...elem,
          label: elem?.name?.replace(/\s/g, "").toLowerCase(),
          img: getSportImageUrl(elem?.name?.replace(/\s/g, "_").toLowerCase()),
        }));

        setSportsList(updatedSport);
        if (filteredData?.length === 0) {
          dispatch({
            type: Actions.SET_GAME,
            data: updatedSport[0]?.name,
            Id: updatedSport[0]?.id,
          });
          ActiveGameName = updatedSport[0]?.name;
          SportId = updatedSport[0]?.id;
          setSelectedSportId(updatedSport[0]?.id);
          fetchPlayerData(updatedSport[0]?.id, "sport");
        }
      })();

      return () => {
        // this now gets called when the component unmounts
      };
    }
  }, [browsereventId]);

  useEffect(() => {
    checkGeoLocation();
  }, []);

  const fetchPlayerData = async (selectedGameId, name, isLeagueorSport) => {
    if (selectedGameId != "") {
      if (browsereventId && isLeagueorSport) {
        selectedGameId = browsereventId;
        let url =
          name == "league"
            ? `${
                sportEndPoint.apiBaseUrl +
                sportEndPoint.api.MultiplayerleagueData +
                selectedGameId
              }`
            : `${
                sportEndPoint.apiBaseUrl +
                sportEndPoint.api.MultiplayersportsData +
                selectedGameId
              }`;

        try {
          let result = await getData(url);
          setIsLoading(false);
          if (result?.events?.length > 0) {
            let gameName =
              name == "league"
                ? result?.events[0]?.league.name
                : result?.events[0]?.sport.name;

            if (gameName == ActiveGameName || gameName == "NCAA Basketball") {
              const datevalue = result.dateList.indexOf(browserdate);

              const eventsArray = result.events;

              // Method to group the result.events array with dates

              function filterArrayByDate(eventsArray, browserdate) {
                return eventsArray.filter(
                  (item) => item.displayDate === browserdate
                );
              }

              const resultArray = filterArrayByDate(eventsArray, browserdate);

              const matchtabvalue = resultArray.findIndex(
                (obj) => obj.shortEventName === browsermatch
              );

              // Since findIndex returns -1 when values is not found in array so applying condition

              setDateIndexvalue(datevalue != -1 ? datevalue : dateIndexvalue);

              tabIndexValue =
                matchtabvalue != -1 && datevalue != -1
                  ? matchtabvalue
                  : tabIndexValue;

              let dateList = getKeyPairList(result.dateList);

              let matchList =
                datevalue != -1
                  ? getMatchListData(result.events, dateList[datevalue].name)
                  : getMatchListData(result.events, dateList[0].name);

              const findmatch = result.events.find(
                (league) => league.shortEventName == browsermatch
              );

              const mainmatch =
                findmatch && datevalue ? findmatch.eventName : "";

              setActiveMatchTabName(
                mainmatch && datevalue != -1
                  ? mainmatch
                  : matchList[tabIndexValue].name
              );
              setActiveshortTabName(browsermatch);
              setMatchTabList(matchList);
              setDateList(dateList);
              setPlayerList(result.events);
              setActiveTabName(
                datevalue != -1 ? browserdate : dateList[tabdatevalue].name
              );
            } else {
            }
          } else {
            if (result.status == "SUCCESS") {
              setPlayerList([]);
              setMatchTabList([]);
              setDateList([]);
              setActiveTabName("");
              setActiveMatchTabName("");
            }
          }
        } catch (error) {
          setIsLoading(false);
          console.error("Error:", error);
        }
      } else {
        let url =
          name == "league"
            ? `${
                sportEndPoint.apiBaseUrl +
                sportEndPoint.api.MultiplayerleagueData +
                selectedGameId
              }`
            : `${
                sportEndPoint.apiBaseUrl +
                sportEndPoint.api.MultiplayersportsData +
                selectedGameId
              }`;

        try {
          let result = await getData(url);
          setIsLoading(false);
          if (result?.events?.length > 0) {
            let gameName =
              name == "league"
                ? result?.events[0]?.league?.name
                : result?.events[0]?.sport?.name;

            if (gameName == ActiveGameName || gameName == "NCAA Basketball") {
              let dateList = getKeyPairList(result?.dateList);
              let matchList = getMatchListData(
                result.events,
                dateList[tabdatevalue].name
              );
              setActiveMatchTabName(matchList[tabIndexValue]?.name);
              setActiveshortTabName(matchList[tabIndexValue]?.shortname);
              setMatchTabList(matchList);
              setDateList(dateList);
              setPlayerList(result?.events);
              setActiveTabName(dateList[tabdatevalue]?.name);
            } else {
            }
          } else {
            if (result.status == "SUCCESS") {
              setPlayerList([]);
              setMatchTabList([]);
              setDateList([]);
              setActiveTabName("");
              setActiveMatchTabName("");
            }
          }
        } catch (error) {
          setIsLoading(false);
          console.error("Error:", error);
        }
      }
    }
  };

  useEffect(() => {
    const timer = setInterval(() => {
      if (selectedLeagueId || leagueId) {
        let id = leagueId;
        fetchPlayerData(id, "league");
      } else if (selectedSportId || SportId) {
        let id = SportId;
        fetchPlayerData(id, "sport");
      }
    }, SPORTS.GameTimeOut);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (state.auth.isAuthenticated) {
      getUserOfferList();
    }
  }, [state.auth.isAuthenticated]);
  const getUserOfferList = async () => {
    const { user } = state?.auth;
    let url = `${endPoints.api.OFFER_USER}/${user?.idUser}`;
    let result = await getAllData(url);
    if (result.status == "success") {
      const filteredRows = result?.data?.filter(
        (item) => item.isfeatured == 1 || item.isactive == 1
      );
      setOfferList(filteredRows);
    }
  };
  const [searchQuery, setSearchQuery] = useState("");
  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };
  const navigateToPromo = () => {
    //navigate("/promotions");

    dispatch({
      type: Actions.SET_GAME,
      data: "promo",
      Id: "1",
    });
  };

  const navigateToOffer = () => {
    // navigate("/offer");
    dispatch({
      type: Actions.SET_GAME,
      data: "offer",
      Id: "1",
    });
  };

  const navigateToEntries = () => {
    if (state.auth.isAuthenticated) {
      navigate("/my-entries");
      dispatch({
        type: Actions.TEST_CASE,
        data: false,
      });
    } else {
    }
  };

  const checkGeoLocation = async () => {
    const result = await checkGeoAndVpn(dispatch);
    dispatch({
      type: Actions.LOCATION_RESPONSE,
      data: result,
    });
    if (result) {
      setGeoResult(true);
    } else {
      setGeoResult(false);
    }
  };
  function handleAllsports(item, index, name) {
    LeagueVisit(state?.auth?.user?.idUser || "", item?.name);
    setSearchQuery("");
    
    history.replace("/");

    deeplink.delete("eventId");
    deeplink.delete("date");
    deeplink.delete("match");

    if (browsereventId || browserdate || browsermatch) {
      browsereventId = null;
      browserdate = null;
      browsermatch = null;
    }

    ActiveGameName = item?.name;
    dispatch({
      type: Actions.SET_GAME,
      data: item?.name,
      Id: item?.id,
    });
    tabdatevalue = 0;
    tabIndexValue = 0;
    setTabList([]);
    setPlayerList([]);
    setMatchTabList([]);
    setDateList([]);
    setActiveTabName("");
    setActiveMatchTabName("");
    setIsLoading(true);

    if (name == "sport") {
      setSelectedSportId(item.id);
      SportId = item.id;
      leagueId = "";
      setSelectedLeagueId("");
      fetchPlayerData(item.id, "sport");
    } else if (name == "league") {
      setSelectedLeagueId(item.id);
      leagueId = item.id;
      SportId = "";
      setSelectedSportId("");
      fetchPlayerData(item.id, "league");
    }
  }

  const clearall = () => {
    setSearchQuery("");
  };

  const Promostyles = {
    fontSize: "15px",
    fontFamily: "inter",
    fontWeight: 700,
    color: selectedGame === "promo" ? "white" : "#06457b",
  };
  const offerStyles = {
    fontSize: "15px",
    fontFamily: "inter",
    fontWeight: 700,
    color: selectedGame === "offer" ? "white" : "#0d3862",
  };
  const socialStyle = {
    fontSize: "15px",
    fontFamily: "inter",
    fontWeight: 700,
    color: "#0d3862",
    marginLeft: "10px",
    textDecoration: "none",
  };

  const Myentriesstyle = {
    fontSize: "15px",
    fontFamily: "inter",
    fontWeight: 700,
    color: "#06457b",
  };

  useEffect(() => {
    fetchplayerOpen(state?.auth?.user?.idUser);
  }, []);

  const fetchplayerOpen = (userId) => {
    let url = `${sportEndPoint.apiBaseUrl}${sportEndPoint.api.PENDING_BETS}/${userId}`; //&status=PENDING

    fetchAllData(url)
      .then((res) => res.json())
      .then((response) => {
        setopenLength(Object.keys(response)?.length);
      })
      .catch((error) => {
        console.log("error");
      });
  };

  const gamevisit = (name) => {
    GameVisit(state?.auth?.user?.idUser || "", name?.shortname);
  };

  return (
    <div fluid style={{ display: "flex", marginTop: "-7px" }}>
      <Helmet>
        <title>Play Daily Fantasy Sports | BettDraft</title>
        <meta name="description" content="Pick your players and build your fantasy lineup. Mix & match NFL, NBA, MLB, NHL and MLS players on BettDraft." />
      </Helmet>
      <div
        className="col-md-2 col-lg-2 hide-ipad "
        style={{
          marginTop: pathname === "/" ? "5px" : "5px",
          marginLeft: "0px",
          width: "15%",
        }}
      >
        <div className="space-sidebar mt-2" style={{ paddingTop: "7px" }}>
          <a
            style={{
              fontSize: "16px",
              fontFamily: "inter",
              fontWeight: "bold",
              color: "#c02640",
              marginLeft: "10px",
              textDecoration: "underline",
              paddingTop: "12px",
              cursor: "pointer",
            }}
            onClick={() => {
              // alert("sdfsd");
              dispatch({
                type: Actions.REMOVE_ALL_BETSLIP,
              });
              dispatch({
                type: Actions.PARLAY_BETS,
                data: false,
              });
              localStorage.setItem("WEBSITE", "P2P");
              window.location.reload();
            }}
          >
            DFS Pools
          </a>
        </div>
        <div className="space-sidebar mt-1">
          <div>
            <div>
              <div className="sidebar-header">
                <h2
                  style={{
                    color: "#0D3862!important",
                    marginTop: "10px",
                    fontSize: "16px",
                    fontWeight: "bold",
                    marginLeft: "10px",
                    marginBottom: "15px!important",
                  }}
                >
                  Sports
                </h2>
              </div>
              <div className="sidebar-link-div">
                {league?.map((ele, index) => {
                  return (
                    <div
                      className="sideBar-game"
                      onClick={() => handleAllsports(ele, index, "league")}
                    >
                      <LabelWithImage
                        data={ele}
                        onClick={() => handleAllsports(ele, index, "league")}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          <div className={"sidebar-Sportbook "}>
            <div
              className={
                auth.isAuthenticated && !sidebar.isSideBarOpen
                  ? "space-sidebar-collapse"
                  : "sidebar-Sportbook-without-coll"
              }
            >
              <div className="sidebar-header"></div>
              <div className="sidebar-link-div">
                {/* sports not required in new functioanlty */}
                {/* {sportsList?.map((ele, index) => {
                  return (
                    <div
                      className="sideBar-game"
                      onClick={() => handleAllsports(ele, index, "sport")}
                    >
                      <LabelWithImage
                        data={ele}
                        onClick={() => handleAllsports(ele, index, "sport")}
                      />
                    </div>
                  );
                })} */}
              </div>
            </div>
          </div>
        </div>

        {/* comment the promotions option as currenlty not showing any marketing */}
        {/* <div className="space-sidebar mt-2">
          <div className="">
            <div className="sideBar-game">
              <div
                className={
                  selectedGame === "promo"
                    ? "link-div-Sportbook pt-2 side-promo-link-selected"
                    : "link-div-Sportbook  pt-2"
                }
                onClick={() => navigateToPromo()}
              >
                <div className="promo-icon">
                  <AiOutlineDollarCircle
                    size={20}
                    color={selectedGame === "promo" ? "white" : "#06457b"}
                  />
                </div>

                <div className="Sport-count-name">
                  <span style={Promostyles}> {"Promotions"}</span>
                </div>
                
              </div>
            </div>
          </div>
        </div> */}

        <FooterAppButton
          style={{
            marginLeft: "5px",
            cursor: "pointer",
            background: "#179624",
            border: "none",
            width: "89%",
            // padding: "0px 40px",
            borderRadius: "10px",
            marginTop: "8px",
          }}
        />

        {state.auth.isAuthenticated ? (
          <div className="space-sidebar mt-2">
            <div className="">
              <div className="sideBar-game">
                <div
                  className={"link-div-Sportbook pt-2"}
                  onClick={() => navigateToEntries()}
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  {/* <div className="promo-icon">
                  <AiOutlineDollarCircle size={20} color={"#06457b"} />
                </div> */}

                  <div className="Sport-count-name">
                    <span style={Myentriesstyle}> {"My Entries"}</span>
                  </div>

                  {state.auth.isAuthenticated ? (
                    <div className="open-count">
                      <span
                        style={{
                          color: "#C02640",
                          fontSize: "15px",
                          fontWeight: "700",
                          textAlign: "end",
                        }}
                      >
                        {" "}
                        {openlength}
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : null}
        <div className="space-sidebar mt-2">
          <div className="">
            <div className="sideBar-game">
              <div
                className={"link-div-Sportbook pt-2"}
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div className="Sport-count-name">
                  <a
                    style={socialStyle}
                    href={"https://play.spinsagacasino.com/"}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {" "}
                    {"Social Casino"}{" "}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* offer display menu code */}
        {state.auth.isAuthenticated && offerList?.length > 0 && (
          <div className="space-sidebar mt-2">
            <div className="">
              <div className="sideBar-game">
                <div
                  className={
                    selectedGame === "offer"
                      ? "link-div-Sportbook pt-2 side-promo-link-selected"
                      : "link-div-Sportbook  pt-2"
                  }
                  onClick={() => navigateToOffer()}
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div className="promo-icon">
                    <BiSolidOffer
                      size={20}
                      color={selectedGame === "offer" ? "white" : "#06457b"}
                    />
                    <span style={offerStyles}> {"Offers"}</span>
                  </div>

                  {offerList?.length > 0 && (
                    <div className="open-count">
                      <span
                        style={{
                          color: selectedGame === "offer" ? "white" : "#C02640",

                          fontSize: "15px",
                          fontWeight: "700",
                          textAlign: "end",
                        }}
                      >
                        {offerList?.length}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="col-md-10 mainplayerbox mt-4 ipad-w100">
        {selectedGame === "offer" || selectedGame === "promo" ? (
          <div>
            {selectedGame === "promo" && <PromotionList />}
            {selectedGame === "offer" && <OfferList data={offerList} />}
          </div>
        ) : (
          <>
            <div className="sidebar-link-div nav-tab-div mobile-sidebar show-ipad">
              <div className="d-flex ">
                {league?.map((ele, index) => {
                  const activeClass = selectedGame == ele?.name ? "active" : "";

                  return (
                    <div
                      className={activeClass}
                      style={{ display: "flex", alignItems: "center" }}
                      onClick={() => handleAllsports(ele, index, "league")}
                    >
                      <img
                        alt="bettdraft"
                        src={ele?.img}
                        style={{ height: "18px" }}
                      />
                      <h1 style={{ marginLeft: "10px", marginTop: "7px" }}>
                        {ele?.name}
                      </h1>
                    </div>
                  );
                })}

                {/* sports not required in new functioanlty */}
                {/* {sportsList?.map((ele, index) => {
                  const activeClass = selectedGame == ele?.name ? "active" : "";

                  return (
                    <div
                      className={activeClass}
                      onClick={() => handleAllsports(ele, index, "sport")}
                    >
                      <img
                        alt="bettdraft"
                        src={ele?.img}
                        style={{ height: "18px" }}
                      />
                      <h1>{ele?.name}</h1>
                    </div>
                  );
                })} */}
              </div>
            </div>

            {/* hide depsoit message */}
            {/* <DepositMessage/> */}

            {/* Floating mobile-only action icon */}
            {/* {!(state?.auth?.user?.dailyLoginClaim) && (
            <div
              className="mobile-fab"
              onClick={() => {
               handleOpenWheel();
              }}
              title="Offers"
            >
              <button className="fab-btn" aria-label="Offers">
                <BiSolidGift size={28} />
              </button>
            </div>
            )} */}

            {/* <WheelOfFortune 
                    open={openWheel} 
                    handleClose={handleCloseWheel}
                     onClose={() => setOpenWheel(false)} 
                     wofData={wofData}
             /> */}

            <div className="tab-section-div new-tab-section">
              <Row>
                <Col lg="12">
                  <div className="nav-tab-div2 mainupper mt-2">
                    <Box sx={{ borderBottom: 2, borderColor: "divider" }}>
                      {auth.isAuthenticated ? (
                        <div className="alerts" style={{ marginTop: "18px" }}>
                          {auth?.user?.verification == "1" && !email_popup ? (
                            <Mailverified />
                          ) : (
                            ""
                          )}
                          {auth?.user?.verification == "0" ? (
                            <MailVerification />
                          ) : (
                            ""
                          )}
                          {geoResult && <FailedGeocheck />}
                        </div>
                      ) : (
                        ""
                      )}
                      <Tabs
                        value={browsereventId ? dateIndexvalue : tabdatevalue}
                        onChange={handleDateChange}
                        aria-label="basic tabs example"
                        variant="scrollable"
                        scrollButtons="auto"
                        style={{
                          borderBottom: "1px solid rgb(212 216 220)",
                          marginLeft: "10px",
                        }}
                        className="uppertab"
                      >
                        {dateList?.length > 0 &&
                          dateList?.map((item, index) => {
                            return (
                              <Tab
                                data="Points"
                                label={item?.name}
                                key={item?.id}
                                onClick={() => {
                                  let matchList = getMatchListData(
                                    playerList,
                                    item?.name
                                  );
                                  setMatchTabList(matchList);
                                  setActiveMatchTabName(matchList[0]?.name);
                                  setActiveshortTabName(
                                    matchList[0]?.shortname
                                  );
                                  setActiveTabName(item?.name);
                                  history.replace("/");
                                }}
                              >
                                {item?.name}
                              </Tab>
                            );
                          })}
                      </Tabs>
                    </Box>
                  </div>
                </Col>

                <Col lg="8" xs="12">
                  <div className="nav-tab-div mt-2 sub-tab-section">
                    <Box sx={{ borderBottom: 2, borderColor: "divider" }}>
                      <Tabs
                        value={tabIndexValue}
                        onChange={handleChange}
                        aria-label="basic tabs example"
                        variant="scrollable"
                        scrollButtons="auto"
                      >
                        {matchTabList?.map((item, index) => {
                          return (
                            <Tab
                              data="Points"
                              label={item?.shortname}
                              key={item?.id}
                              onClick={() => {
                                setActiveMatchTabName(item?.name);
                                setActiveshortTabName(item?.shortname);
                                history.replace("/");
                                gamevisit(item);
                              }}
                            >
                              {item.name}
                            </Tab>
                          );
                        })}
                      </Tabs>
                    </Box>
                  </div>
                </Col>

                 <Col lg="4" xs="12">
                  <div className="search-box-div mt-2">
                    <input  
                      type="text"
                      className="search-input player-search-input"
                      placeholder="Search Player" 
                      value={searchQuery}
                      onChange={handleSearch}
                    />
                    {/* {searchQuery && ( 
                      <AiOutlineCloseCircle
                        className="search-clear-icon"
                        size={20}
                        onClick={() => setSearchQuery('')}
                      />
                    )} */}
                  </div>
                </Col>

              </Row>
            </div>

            {isLoading && <Loader spinner={false} visible={isLoading} />}
            {matchTabList?.length > 0 &&
              matchTabList?.map((item, index) => {
                return (
                  <TabPanel value={tabIndexValue} index={index}>
                    <MultiPlayerCard
                      playerList={playerList}
                      searchQuery={searchQuery}
                      activeTabName={activeTabName}
                      activeMatchTabName={activeMatchTabName}
                      activeshortTabName={activeshortTabName}
                    />
                  </TabPanel>
                );
              })}
            {matchTabList?.length == 0 && (
              <MultiPlayerCard
                playerList={playerList}
                searchQuery={searchQuery}
                activeTabIndex={activeIndex}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default MultiPlayerGames;
